var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tabs',{attrs:{"tabs":_vm.tabs,"currentTab":_vm.currentTab,"wrapper-class":'default-tabs',"tab-class":'default-tabs__item',"tab-active-class":'default-tabs__item_active',"line-class":'default-tabs__active-line'},on:{"onClick":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }